import React,{useState,useEffect} from "react";
import Navbar from "../../navbar/navbar";
import { api } from "../../../services/api";
import { Link,Navigate,useParams } from 'react-router-dom'
import './contas.css'
import { vhostV1 } from "../../funcoes";
import "react-datepicker/dist/react-datepicker.css";
import BuscaVazaia from "../../components/buscavazia/buscaVazia";
import moment from "moment/moment";
import FooterBar from "../../footer/footerBar";
import ModalPagamentos from "./modalPagamentos";
import SRI_pagination from "../../components/pagination/pagination";
import SweetAlert from "react-bootstrap-sweetalert";


function NovaConta(props){

    const {tpc} = useParams();
    const {id} = useParams();

   
   const [sucesso,setSucesso] = useState('N')
   const [mensagem, setMensagem] = useState('');
   const [responsavel,setResponsavel] = useState(0);
   const [razao,setRazao] = useState('');
   const [descricao,setDescricao] = useState('');
   const [valor,setValor] = useState(0);
   const [juros,setJuros] = useState(0);
   const [multa,setMulta] = useState(0);
   const [valorPago, setValorPago] = useState(0);
   const [saldo, setSaldo]= useState(0);
   const [desconto,setDesconto] = useState(0);
   const [documento,setDocumento] = useState('');
   const [tipo_cobranca,setTipoCobranca] = useState(0);
   const [forma_pagamento,setFormaPagamento] = useState(0);
   const [cadastro_por,setCadastroPor] = useState(99);
   const [alterado_por,setAlteradoPor] = useState(99);
   const [tipo_conta,setTipoConta] = useState('');
   const [cod_colaborador,setCodColaborado] = useState(99);
   const [sintetico,setSintetico] = useState(0);
   const [analitico,setAnalitico] = useState(99);
   const [centrocusto,setCentro_custo] = useState(0);
   const [seq_banco,setSeqBanco] = useState(0);
   const [cod_finalizadora,setCodFinalizado] = useState(0);
   const [nosso_numero,setNossoNumero] = useState('');
   const [pessoas,setPessoas] = useState([])
   const [buscaPessoa,setBuscaPessoa] = useState('');
   const [resultPessoa,setResultPessoa] = useState(0);
   const [dataVenc,setDataVenc] = useState('');
   const [planoSintetico,setPlanoSintetico] = useState([]); 
   const [planoAnalitico,setPlanoAnalitico] = useState([]);    
   const [linha_digitavel,setLinhaDigitavel] = useState('');
   const [banco,setbanco] = useState([]);
   const [parcelas,setParcelas] = useState(1);
   const [dataEmissao,setDataEmissao] = useState(new Date());
   const [dataSEmissao,setSDataEmissao] = useState('');
   const [dataSVenc,setDataSVenc] = useState('');
   const [modalData, setModalData] = useState(null);
   const [isModalOpen, setIsModalOpen] = useState(false);
   const [resultConta, setResultConta] = useState(0);
   const [pagamentosConta, setPagamentosConta] = useState([]);
   const [nPag,setnPag] = useState(1);
   const [totalPaginas,setTotalPaginas] = useState(0); 
   const [busca,setBusca] = useState('');
   const [msgErro, setMsgErro] = useState('');
   const [erroValidacao, setErrovalidacao] = useState(false);
   
   
  
   var dataAtual = moment().format('YYYY-MM-DD');
  


  function setEmissao(sData){

    
   setSDataEmissao(dataAtual)
   setDataEmissao(sData);
   

  }

  function setVencimento(sData){

    setDataSVenc(sData+'T00:00:00.000Z');
    setDataVenc(sData)
  }

  function validarData(dataString) {
    var data;

    // Verifica se a data está no formato "dd/mm/yyyy"
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(dataString)) {
        var partes = dataString.split('/');
        var dia = parseInt(partes[0]);
        var mes = parseInt(partes[1]) - 1; // Mês começa do zero (janeiro é 0)
        var ano = parseInt(partes[2]);
        data = new Date(ano, mes, dia);

        // Verifica se a data é válida
        if (data.getDate() !== dia || data.getMonth() !== mes || data.getFullYear() !== ano) {
            return null;
        }
    } else {
        // Tenta criar data a partir do formato ISO (ex: "2022-12-30T03:00:00.000Z")
        data = new Date(dataString);
        if (isNaN(data.getTime())) {
            return null; // Data inválida
        }
    }

    // Formata a data no formato "yyyy-mm-dd"
    var dataFormatada = data.getFullYear() + '-' +
        ('0' + (data.getMonth() + 1)).slice(-2) + '-' +
        ('0' + data.getDate()).slice(-2);
    return dataFormatada;
}


useEffect(function() {
  const novoSaldo = Number(valor) + Number(juros) + Number(multa) - Number(valorPago);
  setSaldo(novoSaldo);
  console.log(novoSaldo);
}, [valor, juros, multa, valorPago]);



   let config = {
    headers: {
      'Authorization': localStorage.getItem("token")
       }
    }

   function SalvaConta(e){
    e.preventDefault();


    if (Number(analitico) === 99) {
      setMsgErro('Selecione o analítico');
      setErrovalidacao(true);
      return;
    } else if (Number(sintetico) === 0) {
      setMsgErro('Selecione o sintético');
      setErrovalidacao(true);
      return;
    } else if (Number(valor) <= 0) {
      setMsgErro('Valor deve ser maior que zero');
      setErrovalidacao(true);
      return;
    }

    
    
    

    const sJson = {};
    if(id > 0){
      sJson.SEQ=Number(id);
    }
    sJson.loja= localStorage.getItem('loja');
    sJson.EMPRESA=0;
    sJson.RESPONSAVEL=Number(responsavel);
    sJson.PARCELA= parcelas;
    sJson.DATA_EMISSAO=dataEmissao;
    sJson.DATA_VENC=dataSVenc;
    sJson.DESCRICAO=descricao;
    sJson.VALOR=Number(valor);
    sJson.JUROS=Number(juros);
    sJson.MULTA=Number(multa);
    sJson.DESCONTO=0;
    sJson.INTEGRAL="F";
    sJson.DOCUMENTO=documento;
    sJson.CFOP="0000";
    sJson.TIPO_MOVIMENTO= 1;
    sJson.CANCELADO="F";
    sJson.PLANO_CONTA=0;
    sJson.TIPO_COBRANCA=tipo_cobranca;
    sJson.FORMA_PAGAMENTO=0;
    sJson.COMISSAO= 0;
    sJson.VALOR_PAGO=Number(valorPago);
    sJson.TOTAL_PAGAR=Number(saldo);
    sJson.CADASTRADO_POR=Number(localStorage.getItem('colaborador'));
    sJson.CADASTRADO_EM=dataEmissao;
    sJson.ALTERADO_POR=Number(localStorage.getItem('colaborador'));
    sJson.ALTERADO_EM=dataEmissao;
    sJson.TIPO_CONTA=tpc;
    sJson.COD_COLABORADOR=localStorage.getItem('colaborador');
    sJson.SINTETICO=Number(sintetico);
    sJson.ANALITICO=Number(analitico);
    sJson.CENTRO_CUSTO=0;
    sJson.SEQ_BANCO=seq_banco;
    sJson.NR_CHEQUE= 0;
    sJson.COD_FINALIZADORA=0;
    sJson.CAIXA="00";
    sJson.NOSSO_NUMERO=nosso_numero;
    sJson.LOTE_REMESSA="";
    sJson.LINHA_DIGITAVEL="";
    sJson.CONFIRMADO="T";
    api.post(vhostV1('webcash/contas/incluirConta'),
        sJson                        
    ,config)
    .then(function(response){
        console.log(sJson);
        console.log(response+'estou aqui');
        setMensagem('');
        setSucesso('S');
        console.log('passei' )
    }).catch((erro) =>{
        setMensagem(erro);
        setSucesso('N');
        console.log(erro)
    });   
    
   }

    //  useEffect(function(){
   
    //       api.post(vhostV1('webcash/cadastro'), {
    //          loja: localStorage.getItem('loja'),
    //          empresa: 1,
    //          pagina: nPag,
    //          regPag: 10,
    //          tipo:tp,
    //          busca: busca
    //        },config)
    //        .then(function (response) {
    //          setSresult(response.data.result); 
    //          setCadastro(response.data.dados);
    //          setTotalPaginas(response.data.quantidadePagina);
    //          console.log(response);
             
    //          setRefresh(true);
                                                 
                      
    //        })
    //        .catch(function (error) {
            
    //          console.log(error);
    //          setRefresh(true);
   
                     
    //        });
     
           
    //    },[busca,nPag])
   
   


   function listaPessoa(e){
    // e.preventDefault();
    api.post(vhostV1('webcash/cadastro'), {
        loja: localStorage.getItem('loja'),
        empresa: 1,
        tipo:"%",
        busca: buscaPessoa,
        pagina: nPag,
        regPag: 10
      },config)
      .then(function (response) {
        setPessoas(response.data.dados);  
        setResultPessoa(response.data.result);
        setTotalPaginas(response.data.quantidadePagina);
        console.log(response);                                  
                 
      })
      .catch(function (error) {
       
        console.log(error);

                
      });
    }


    function pesquisaPessoa(e){
        console.log(e.substring(1,6));
        setResponsavel(e.substring(1,6));
        setRazao(e.substring(9,50));
        
    }

    useEffect(function(){
      if(sintetico > 0){
        buscaAnalitico(Number(sintetico)
    )}
    },[sintetico])

    
   function buscaAnalitico(e){
    
    api.post(vhostV1('webcash/planoConta/planoAnalitico'), {
        loja: localStorage.getItem('loja'),
        empresa: 1,
        sintetico:e
      },config)
      .then(function (response) {
        console.log(response);
        
        setPlanoAnalitico(response.data.dados);  
        setSintetico(e);
                             
      })
      .catch(function (error) {       
        console.log(error);
      });
    }


   //se editar conta
   useEffect(function(){
    api.post(vhostV1('webcash/contas/'+id), {
        loja: localStorage.getItem('loja'),
        empresa: 0        
      },config)
      .then(function (response) {
          console.log('busquei');
          if(response && response.data && response.data.dados){
          console.log(response.data.dados);
          setResponsavel(response.data.dados.RESPONSAVEL);
          setRazao(response.data.dados.RAZAO);
          setSintetico(response.data.dados.SINTETICO);
          setAnalitico(response.data.dados.ANALITICO);
          setValor(response.data.dados.VALOR);
          setSeqBanco(response.data.dados.SEQ_BANCO);
          setTipoCobranca(response.data.dados.TIPO_COBRANCA);
          setDocumento(response.data.dados.DOCUMENTO);
          setNossoNumero(response.data.dados.NOSSO_NUMERO);
          setDescricao(response.data.dados.DESCRICAO);
          setDataEmissao(validarData(response.data.dados.DATA_EMISSAO));
          setDataVenc(validarData(response.data.dados.DATA_VENC));
          setDataSVenc(validarData(response.data.dados.DATA_VENC));
          setTipoConta(response.data.dados.TIPO_CONTA);
          setJuros(response.data.dados.JUROS);
          setMulta(response.data.dados.MULTA);
          setValorPago(response.data.dados.VALOR_PAGO);
          setSaldo(response.data.dados.TOTAL_PAGAR);
          }
          else 
          {
            setDataEmissao(dataAtual);
            
          } 
                    

        }                               
      )
      .catch(function (error) {
        console.log(error);
                
      });
           
  },[])


  const formatarValor = (value) => {
    const numberValue = parseFloat(value.replace(/\D/g, '')) / 100; 
    return numberValue;
  };

  
  const formatarExibicao = (valor) => {
    return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };


    //Buscar Historico de Contas
    // useEffect(function(){
    //     api.post(vhostV1('webcash/tesouraria/listaRecebidos'), {
    //         loja: localStorage.getItem('loja'),
    //         empresa: 0,
    //         conta: Number(id)
    //       },config)
    //       .then(function (response) { 
    //         console.log(response);
    //         setResultConta(response.data.result);
    //         setPagamentosConta(response.data.dados);
            
            
                     
    //         }                               
    //       )
    //       .catch(function (error) {
    //         console.log(error);
                    
    //       });
    
  
          
    //   },[id])

    useEffect(function(){
      api.post(vhostV1('webcash/tesouraria/listaRecebidos'), {
          loja: localStorage.getItem('loja'),
          empresa: 1,
          cod: Number(id)
        },config)
        .then(function (response) { 
          console.log(response);
          setResultConta(response.data.result);
          setPagamentosConta(response.data.dados);
          
          
                   
          }                               
        )
        .catch(function (error) {
          console.log(error);
                  
        });
  

        
    },[id])


  const handleOpenModal = (e) => {
    e.preventDefault();

    if(resultConta === undefined || null){
      setModalData(
        
        "Não há registro de pagamentos para a conta selecionada.",
        
      )
    }else if(Number(resultConta) === 0){
      setModalData(
        
        "Não há registro de pagamentos para a conta selecionada.",
        
      )
    }else{
      setModalData(
       
       pagamentosConta
        
      );
    }
    
    
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setModalData(null);
  };


//   //buscar Sintetico
//   useEffect(function(){
//     api.post(vhostV1('webcash/planoSintetico'), {
//         loja: localStorage.getItem('loja'),
//         empresa: 0,
//       },config)
//       .then(function (response) {
//         console.log(response.data.dados);
//         setPlanoSintetico(response.data.dados)
        
//       }                             
//       )
//       .catch(function (error) {
//         console.log(error);
                
//       });
//  },[])

  //buscar Sintetico
  useEffect(function(){
    api.post(vhostV1('webcash/planoConta/planoSintetico'), {
        loja: localStorage.getItem('loja'),
        empresa: 0,
      },config)
      .then(function (response) {
        console.log(response);
        setPlanoSintetico(response.data.dados)
        
      }                             
      )
      .catch(function (error) {
        console.log(error);
                
      });
 },[])


 // busca bancos
 useEffect(function(){
  api.post(vhostV1('webcash/banco'), {
      loja: localStorage.getItem('loja'),
      empresa: 1,
      busca: ''  
    },config)
    .then(function (response) {
      if(response && response.data && response.data.dados){
       setbanco(response.data.dados);
       console.log(response.data.dados);           
      }}                               
    )
    .catch(function (error) {
      console.log(error);
              
    });
},[])

function handlePageChange(value) {

  if(value === "&laquo;" || value === '... '){
    setnPag(1);
    listaPessoa(1);
  } else if (value === "&lsaquo;"){
    if (nPag !== 1){
      setnPag(nPag - 1);
      listaPessoa(nPag - 1);
    }
  } else if(value === "&rsaquo;"){
    setnPag(nPag + 1);
    listaPessoa(nPag + 1);
  } else if(value === "&raquo;" || value === ' ...'){
    setnPag(totalPaginas);
    listaPessoa(totalPaginas);
  } else {
    setnPag(value);
    listaPessoa(value);
  }
}




return (
  <div className="container-fluid">
    <Navbar />
    <div className="offset-3 col-lg-6">
      <h2>{tpc === 'R' ? 'Cadastro de Contas Receber' : 'Cadastro de Contas Pagar'}</h2>
      <div className="container-fluid">
        <form className="row tela">
          {/* Código */}
          {id !== 0 && (
            <div className="col-12 mb-3 mt-5">
              <label htmlFor="inputID" className="form-label">Código</label>
              <input type="text" value={id} className="form-control" id="inputID" disabled />
            </div>
          )}

          <div className="col-5 mb-3">
            <label htmlFor="inputDocumento" className="form-label">Documento</label>
            <input type="text" value={documento} onChange={(e) => setDocumento(e.target.value)} className="form-control" id="inputDocumento" />
          </div>

          <div className="col-5 mb-3">
            <label htmlFor="inputNossoNumero" className="form-label">Nosso Número</label>
            <input type="text" value={nosso_numero} onChange={(e) => setNossoNumero(e.target.value)} className="form-control" id="inputNossoNumero" />
          </div>

          <div className="col-2 mb-3">
            <label htmlFor="inputParcelas" className="form-label">Parcelas</label>
            <input type="text" value={parcelas} onChange={(e) => setParcelas(e.target.value)} className="form-control" id="inputParcelas" />
          </div>

          <div className="col-md-12 mb-3">
            <label htmlFor="inputSacado" className="form-label">SACADO</label>
            <div className="input-group">
              <input type="text" value={razao} onChange={(e) => setRazao(e.target.value)} className="form-control" id="inputSacado" disabled />
              <button type="button" className="btn btn-secondary" data-bs-toggle="modal" data-bs-target="#modalPesquisa">Pesquisar</button>
            </div>

            <div className="modal fade" id="modalPesquisa" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="modalPesquisaLabel" aria-hidden="true">
              <div className="modal-dialog modal-lg">
                <div className="modal-content">
                  <div className="modal-header">
                    <h1 className="modal-title fs-5" id="modalPesquisaLabel">Pesquisa Cadastro</h1>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                  <div className="modal-body">
                    <div className="input-group mb-3">
                      <input onChange={(e) => setBuscaPessoa(e.target.value)} type="text" className="form-control" placeholder="Digite sua pesquisa" aria-describedby="button-addon2" />
                      <button onClick={listaPessoa} className="btn btn-primary" type="button" id="button-addon2">
                        <i className="fas fa-search"></i> Pesquisar
                      </button>
                    </div>
                    {resultPessoa === 1 ? (
                      <div>
                      <table className="table table-hover table-striped">
                        <thead>
                          <tr>
                            <th scope="col">Código</th>
                            <th scope="col">Razão</th>
                            <th scope="col">Ação</th>
                          </tr>
                        </thead>
                        <tbody>
                          {pessoas.map(pessoa => (
                            <tr key={pessoa.COD_CADASTRO}>
                              <td>{pessoa.CNPJ}</td>
                              <td>{pessoa.RAZAO}</td>
                              <td>
                                <a href="#" onClick={() => pesquisaPessoa(`000000${pessoa.COD_CADASTRO}`.slice(-6) + ' - ' + pessoa.RAZAO)} data-bs-dismiss="modal">
                                  <i className="fas fa-edit icone-acao red"></i>
                                </a>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <div className="row mt-5 mb-5">
                      <SRI_pagination totalPage={totalPaginas} 
                            page={nPag} 
                            limit={10} 
                            siblings={1}
                            onPageChange={handlePageChange}/>
                        </div>
                     </div>
                      
                       
                    ) : (
                      <BuscaVazaia />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 mb-3">
            <label htmlFor="inputDescricao" className="form-label">Descrição</label>
            <textarea className="form-control" value={descricao} onChange={(e) => setDescricao(e.target.value)} id="inputDescricao" rows="3"></textarea>
          </div>

          <div className="col-6 mb-3">
            <label htmlFor="inputTipoCobranca" className="form-label">Tipo Cobrança</label>
            <select id="inputTipoCobranca" value={tipo_cobranca} onChange={(e) => setTipoCobranca(e.target.value)} className="form-select">
              <option value={1}>CARTEIRA</option>
              <option value={2}>DUPLICATA</option>
              <option value={3}>CHEQUE</option>
            </select>
          </div>

          <div className="col-6 mb-3">
            <label htmlFor="inputBanco" className="form-label">Banco</label>
            <select id="inputBanco" value={seq_banco} onChange={(e) => setSeqBanco(e.target.value)} className="form-select">
              {banco.map(b => (
                <option key={b.SEQ_BANCO} value={b.SEQ_BANCO}>{b.DESCRICAO}</option>
              ))}
            </select>
          </div>

          <div className="col-6 mb-3">
            <label htmlFor="inputSintetico" className="form-label">Sintético</label>
            <select id="inputSintetico" value={sintetico} onChange={(e) => buscaAnalitico(e.target.value)} className="form-select">
              <option value={0}>SELECIONE O SINTETICO</option>
              {planoSintetico.map(ps => (
                <option key={ps.SINTETICO} value={ps.SINTETICO}>{ps.DESCRICAO}</option>
              ))}
            </select>
          </div>

          {planoSintetico.length > 0 && (
            <div className="col-6 mb-3">
              <label htmlFor="inputAnalitico" className="form-label">Analítico</label>
              <select id="inputAnalitico" value={analitico} onChange={(e) => setAnalitico(e.target.value)} className="form-select">
              <option value={99}>SELECIONE O ANALITICO</option>
                {planoAnalitico.map(pa => (
                  <option key={pa.ANALITICO} value={pa.ANALITICO}>{pa.DESCRICAO}</option>
                ))}
              </select>
            </div>
          )}

          <div className="col-12 mb-3">
            <label htmlFor="inputDataEmissao" className="form-label">Data Título</label>
            <div className="row">
              <div className="col-4 mb-3">
                <label htmlFor="inputDataEmissao" className="form-label">Emissão</label>
                <input type="date" value={dataEmissao} className="form-control" disabled />
              </div>
              <div className="col-4 mb-3">
                <label htmlFor="inputDataVencimento" className="form-label">Vencimento</label>
                <input type="date" value={dataVenc} onChange={(e) => setVencimento(e.target.value)} className="form-control" />
              </div>
              <div className="col-4 mb-3">
        <label htmlFor="inputSaldo" className="form-label">Total Conta</label>
        <input
          type="text"
          value={`R$ ${formatarExibicao(valor)}`}
          onChange={(e) => setValor(formatarValor(e.target.value))}
          className="form-control"
          id="inputSaldo"
        />
      </div>
      
      <div className="col-3 mb-3">
        <label htmlFor="inputJuros" className="form-label">Juros</label>
        <input
          type="text"
          value={`R$ ${formatarExibicao(juros)}`}
          onChange={(e) => setJuros(formatarValor(e.target.value))}
          className="form-control"
          id="inputJuros"
        />
      </div>
      
      <div className="col-3 mb-3">
        <label htmlFor="inputMulta" className="form-label">Multa</label>
        <input
          type="text"
          value={`R$ ${formatarExibicao(multa)}`}
          onChange={(e) => setMulta(formatarValor(e.target.value))}
          className="form-control"
          id="inputMulta"
        />
      </div>
      
      <div className="col-3 mb-3">
        <label htmlFor="inputValorPago" className="form-label">Valor Pago</label>
        <input
          type="text"
          value={`R$ ${formatarExibicao(valorPago)}`}
          onChange={(e) => setValorPago(formatarValor(e.target.value))}
          className="form-control"
          id="inputValorPago"
          readOnly
        />
      </div>
      
      <div className="col-3 mb-3">
        <label htmlFor="inputSaldo" className="form-label">Saldo</label>
        <input
          type="text"
          value={`R$ ${formatarExibicao(saldo)}`}
          onChange={(e) => setSaldo(formatarValor(e.target.value))}
          className="form-control"
          id="inputSaldo"
          readOnly
        />
      </div>
            </div>
          </div>

          <div className="col-12 mb-5">
            <Link to="/app/contas" className="btn btn-outline-primary">Desistir</Link>
            <button className="btn btn-primary ml-2" onClick={handleOpenModal}>Historico dos Pagamentos</button>

      {/* Renderização do Modal */}
      {isModalOpen && (
        <ModalPagamentos result={resultConta} data={modalData} onClose={handleCloseModal} />
      )}
            <button type="button" onClick={SalvaConta} className="btn btn-primary ms-2">Salvar</button>
          </div>

          {mensagem && <div className="alert alert-danger mt-2" role="alert">{mensagem}</div>}
          {sucesso === 'S' && <Navigate to='/app/contas' />}
        </form>
      </div>

       {
                             erroValidacao ? 
                             <SweetAlert
                                danger
                                confirmBtnText="OK"
                                confirmBtnBsStyle="danger"
                                title="Erro"
                                onConfirm={() => setErrovalidacao(false)}                            
                              >
                                {msgErro}
                              </SweetAlert>:null
                             
                            } 
    </div>
    <FooterBar/> 
  </div>
);
}


export default NovaConta;